// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";

export interface RemoveCompareProductsConfirmationModalStyles {
    buttonsWrapper?: InjectableCss;
}

export const removeCompareProductsConfirmationModalStyles: RemoveCompareProductsConfirmationModalStyles = {};

interface Props {
    onClose: () => void;
    onClick: () => void;
    isOpen: boolean;
    extendedStyles?: RemoveCompareProductsConfirmationModalStyles;
}

const RemoveCompareProductsConfirmationModal = ({ onClose, onClick, isOpen, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeWithCss(removeCompareProductsConfirmationModalStyles, extendedStyles));

    return (
        <Modal
            sizeVariant="medium"
            headline={translate("Remove All")}
            handleClose={onClose}
            isOpen={isOpen}
        >
            <StyledWrapper>
                <Typography>
                    {translate("Are you sure you want to remove all items?")}
                </Typography>
                <StyledWrapper {...styles.buttonsWrapper}>
                    <Button variant="secondary" onClick={onClose} aria-label="cancel">
                        {translate("Cancel")}
                    </Button>
                    <Button onClick={onClick} aria-label="remove">
                        {translate("Remove")}
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
        </Modal>
    );
};

export default RemoveCompareProductsConfirmationModal;
